module.exports = "";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Home.vue
// module id = 142
// module chunks = 0